import { useIntl } from 'react-intl';

import './reportFooter.scss';

type Props = {
  lastUpdatedAt: string;
};

/**
 * Single-line provenance note at the very bottom of the report: the report's data is
 * calculated once the line item has finished (the coverage study is only requested then).
 */
export default function ReportFooter({ lastUpdatedAt }: Readonly<Props>) {
  const { formatMessage, formatDate, formatTime } = useIntl();
  const updatedAt = new Date(lastUpdatedAt);

  return (
    <p className="reportFooter">
      <b className="reportFooter__lastUpdated">
        {formatMessage(
          {
            defaultMessage: 'Generated on: {date} {time}h.',
            id: 'doohReport.footer.generatedOn'
          },
          {
            date: formatDate(updatedAt, { day: 'numeric', month: 'short', year: 'numeric' }),
            time: formatTime(updatedAt, { hour: '2-digit', minute: '2-digit' })
          }
        )}
      </b>{' '}
      {formatMessage({
        defaultMessage:
          'Data is calculated once the line item has finished. Audience figures are modelled from mobile SDK & bidstream signals; some zones may show no data depending on regional activity.',
        id: 'doohReport.footer.noteLineItemFinished'
      })}
    </p>
  );
}
